var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "header box-shadow main-header"
  }, [_c('h1', {
    staticClass: "main-title"
  }, [_vm._v("外包招聘系统")]), _vm._v(" "), _c('div', {
    staticClass: "header-row"
  }, [_c('div', {
    staticClass: "main-header-right pull-right"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('thumbnail', {
    attrs: {
      "width": 36,
      "mode": "horizontal"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#666"
    },
    domProps: {
      "textContent": _vm._s(_vm.user.name)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "opt-area"
  }, [_c('span', {
    staticClass: "divider"
  }, [_vm._v("|")]), _c('span', {
    staticClass: "opt-text",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("退出")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "main-header-left pull-left"
  }, [_c('i', {
    class: [_vm.folding ? 'el-icon-my-zhankaidaohanglan' : 'el-icon-my-shouqidaohanglan'],
    on: {
      "click": function($event) {
        return _vm.toggleFold(_vm.folding)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "ml-15 mr-5"
  }, [_vm._v("选择项目：")]), _vm._v(" "), _c('el-select', {
    on: {
      "change": function($event) {
        return _vm.projectChange(_vm.projectId)
      }
    },
    model: {
      value: (_vm.projectId),
      callback: function($$v) {
        _vm.projectId = $$v
      },
      expression: "projectId"
    }
  }, _vm._l((_vm.project), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.text,
        "value": parseInt(item.value)
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "menu-inline-block"
  }, [(_vm.showTopMenu > -1) ? [_c('el-menu', {
    attrs: {
      "mode": "horizontal",
      "default-active": _vm.$route.fullPath,
      "router": ""
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": _vm.topMenu.resumeDetail
    }
  }, [_vm._v("简历详情")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": _vm.topMenu.evaluationResume
    }
  }, [_vm._v("简历评价")]), _vm._v(" "), (_vm.hasWritten) ? _c('el-menu-item', {
    attrs: {
      "index": _vm.topMenu.writtenPersonDetail
    }
  }, [_vm._v("笔试安排")]) : _vm._e(), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": _vm.topMenu.singleArrangement
    }
  }, [_vm._v("面试安排")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": _vm.topMenu.evaluation
    }
  }, [_vm._v("面试评价")]), _vm._v(" "), (_vm.hasSalary) ? _c('el-menu-item', {
    attrs: {
      "index": _vm.topMenu.salary
    }
  }, [_vm._v("定薪评价")]) : _vm._e()], 1)] : _vm._e(), _vm._v(" "), (_vm.showInterviewMenu) ? _c('el-menu', {
    staticStyle: {
      "height": "60px",
      "min-width": "250px"
    },
    attrs: {
      "mode": "horizontal",
      "default-active": _vm.$route.path,
      "router": ""
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "/interview/1"
    }
  }, [_vm._v("一面")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/interview/2"
    }
  }, [_vm._v("二面")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/interview/3"
    }
  }, [_vm._v("三面")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/interview/4"
    }
  }, [_vm._v("四面")])], 1) : _vm._e()], 2)])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-157e228a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/common/header.vue
// module id = null
// module chunks = 